const { incognitoTest } = require('src/frontend/helper/incognito');

const GoogleMaps = require('../helper/general/m_google_maps');

const loadAsyncJS = require('../helper/general/m_loadAsyncJS');

const {
  externalObjectLoader,
  externalObjectLoaderOnready,
} = require('../old/groupon_modules/externalObjectLoader');

const getConfigFromDom = require('../helper/general/m_getConfigFromDom');

const trackEvent = require('../helper/general/m_trackEvent');
const unparam = require('../helper/general/m_unparam');

// init Groupon object
if (window.Groupon == null) {
  window.Groupon = {};
}

Object.assign(window.Groupon, {
  PageFlags: {
    isIncognito: incognitoTest('desktop'),
  },
});

if (window.Groupon.LS == null) {
  window.Groupon.LS = {};
}

// For desktop, Modules has been init in the head.
// This is not the case for Touch.
if (window.Groupon.Modules == null) {
  window.Groupon.Modules = {};
}
if (window.Groupon.Utils == null) {
  window.Groupon.Utils = {};
}

Object.assign(Groupon.Utils, {
  getConfigFromDom,
  externalObjectLoader,
  externalObjectLoaderOnready,
  GoogleMaps,
  unparam,
  trackEvent,
  loadAsyncJS,
});
const { documentReady } = require('@grpn/document-states');

function grouponExtended() {
  Object.assign(window.Groupon, {
    App: {
      name: document.head.dataset.app,
    },
  });
}

documentReady.then(() => {
  grouponExtended();
});
